import React, { JSX } from 'react'
import type { Block, HTMLElementProps } from '~/types'
import { cn } from '~/utils'

type Props<T extends keyof JSX.IntrinsicElements = 'section'> = HTMLElementProps<
	T,
	{
		tag?: T
		full?: boolean
		containerCns?: string
	}
>

export const Title: React.FC<HTMLElementProps<'h2'>> = props => (
	<h2 className="mx-auto px-2 text-5xl leading-tight text-inherit md:w-7/12" {...props} />
)

export const Section: React.FC<Props> = ({ full, className, containerCns, ...props }) => {
	if (!props.tag) props.tag = 'section'

	return full ? (
		<props.tag className={className} {...props}>
			{props.children}
		</props.tag>
	) : (
		<props.tag className={containerCns} {...props}>
			<div className={cn('page-width', className)}>{props.children}</div>
		</props.tag>
	)
}

export function attributesToProps(attributes: Block['attributes']) {
	if (!attributes) return {}
	const entries: string[][] = attributes
		.trim()
		.split(' ')
		.map(attr => attr.split('=').map(s => s.replaceAll('"', '').replaceAll('&quot;', '"')))
	return Object.fromEntries(entries)
}
